const contact = {
  email: 'kontakt@szkolarodzenia.pl',
  phone: '+48600954554',
  formattedPhone: '+48 600 954 554',
  address: 'ul. Dworcowa 10a, p.2\n46-300 Olesno',
};

export default contact;
